import styled from 'styled-components'
import { SbButton } from 'uiCore'

export const SettingsActionButtonStyled = styled(SbButton)`
  color: ${p => p.theme?.colors?.gray ?? '#565E70'};

  &:hover {
    color: ${p => p.theme?.colors?.primary ?? '#008080'} !important;
    background: ${p => p.theme?.colors?.hoverBg ?? 'rgba(0, 128, 128, 0.1)'} !important;
  }
`

/*
 * The Save button is wrapped in SbTooltip's TooltipTriggerStyled span, which is
 * display: block — inside Ant's default footer that pushes it onto its own row.
 * A flex row keeps Cancel and Save side by side, right aligned.
 */
export const SettingsModalFooterStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`

export const SettingsModalFormWrapperStyled = styled.div`
  padding-top: 8px;

  .ant-select {
    width: 100%;
  }
`

/* ── Ownership Conflict Modal ── */

export const ConflictProjectListStyled = styled.ul`
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  border-radius: 10px;
`

export const ConflictProjectItemStyled = styled.li`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;

  & + & {
    border-top: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  }
`

export const ConflictProjectNameStyled = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${p => p.theme?.colors?.dark ?? '#2B3034'};
  word-break: break-word;
`

export const ConflictOwnerSelectWrapperStyled = styled.div`
  .ant-select {
    width: 100%;
  }
`

